import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { stabs, stab, dot, iconWrap, badge } from './SideTabs.css';

export interface SideTabItem {
  key: string;
  to: string;
  label: string;
  icon?: ReactNode;
  /** Tint the status dot green (configured) vs gray (not). */
  configured?: boolean;
  /** Tint the status dot amber to flag un-applied changes in this section.
   *  Takes precedence over `configured`. */
  unsaved?: boolean;
  /** Whether to render the status dot at all (Thesis uses dots; Settings does not). */
  showDot?: boolean;
  /** Optional trailing badge text (e.g. "Admin"). */
  badge?: string;
}

export function SideTabs({ items }: { items: SideTabItem[] }) {
  const { pathname } = useLocation();
  return (
    <nav className={stabs} role="tablist" aria-orientation="vertical">
      {items.map(item => {
        const active = pathname === item.to || pathname.startsWith(item.to + '/');
        return (
          <Link key={item.key} to={item.to} role="tab" className={stab} aria-selected={active}>
            {item.showDot && (
              <span className={dot}
                    data-configured={item.configured ? 'true' : undefined}
                    data-unsaved={item.unsaved ? 'true' : undefined}
                    data-testid={`stab-dot-${item.key}`} />
            )}
            {item.icon && <span className={iconWrap}>{item.icon}</span>}
            <span>{item.label}</span>
            {item.badge && <span className={badge}>{item.badge}</span>}
          </Link>
        );
      })}
    </nav>
  );
}
